import a from "./index158.js";
function t(r) {
  if (Array.isArray(r))
    return a(r);
}
export {
  t as default
};
